"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AllProductsNav", {
  enumerable: true,
  get: function () {
    return _mobileNav.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _productNav.default;
  }
});
var _mobileNav = _interopRequireDefault(require("@ux/mobile-nav"));
var _productNav = _interopRequireDefault(require("./product-nav"));
require("@ux/text/styles");
require("@ux/mobile-nav/styles");
require("../css/styles.css");